import StandTableFilter from './stand-table-filter';

export default StandTableFilter;